import React from 'react';
import { Button, Col, Modal } from 'antd';
import './modalConfirm.css'

const ImageModal = ({ visible, onOk, onCancel, source }) => {
   
  return (
    <Modal 
    className='AttachmentsModel'
      title={""}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      
    >
        <img
            style={{
                width: "100%",
                height: "auto",
            }}
            src={source}
            alt=""
            />
    </Modal>
  );
};

export default ImageModal;